import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-77939f38"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "create-form-container",
  ref: "createFormContainer"
}
const _hoisted_2 = { class: "form-card" }
const _hoisted_3 = { class: "form-configuration-sidebar" }
const _hoisted_4 = {
  key: 0,
  class: "sidebar-title text-h5 font-weight-black"
}
const _hoisted_5 = {
  key: 1,
  class: "sidebar-title text-h5 font-weight-black"
}
const _hoisted_6 = { class: "form-name font-weight-black pb-2" }
const _hoisted_7 = { class: "form-description font-weight-black pb-2 pt-3" }
const _hoisted_8 = { class: "form-items-container pt-3" }
const _hoisted_9 = { class: "form-items-container-title font-weight-black pb-2" }
const _hoisted_10 = { class: "items" }
const _hoisted_11 = { class: "switch-options-container" }
const _hoisted_12 = { class: "font-weight-black" }
const _hoisted_13 = {
  class: "font-weight-black",
  style: {"width":"100%"}
}
const _hoisted_14 = { class: "associate-device font-weight-black pb-2" }
const _hoisted_15 = { class: "associated-devices-chip-container" }
const _hoisted_16 = { class: "form-sketch-container" }
const _hoisted_17 = { class: "form-title font-weight-black" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "sketch" }
const _hoisted_20 = { class: "sketch-footer" }
const _hoisted_21 = { class: "sketch-footer-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentContainerNavbar = _resolveComponent("ContentContainerNavbar")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_FormItemCard = _resolveComponent("FormItemCard")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_QuitFormDesignModal = _resolveComponent("QuitFormDesignModal")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_FormPreview = _resolveComponent("FormPreview")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ContentContainerNavbar, {
        title: _ctx.formIdProp ? _ctx.$t('i18n.editFormDesignNavbarTitle') : _ctx.$t('i18n.createFormDesignNavbarTitle')
      }, null, 8, ["title"]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
            key: 0,
            type: "table"
          }))
        : (_openBlock(), _createBlock(_component_v_form, {
            key: 1,
            onSubmit: _withModifiers(_ctx.submitForm, ["prevent"]),
            ref: "form"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.formIdProp)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('i18n.editForm')), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('i18n.createForm')), 1)),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('i18n.formName')), 1),
                  _createVNode(_component_v_text_field, {
                    density: "compact",
                    variant: "outlined",
                    dense: "",
                    "hide-details": "auto",
                    modelValue: _ctx.formObject.form.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formObject.form.name) = $event)),
                    clearable: "",
                    rules: _ctx.nameRules
                  }, null, 8, ["modelValue", "rules"]),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('i18n.description')), 1),
                  _createVNode(_component_v_text_field, {
                    class: "form-description-text-field",
                    density: "compact",
                    variant: "outlined",
                    dense: "",
                    "hide-details": "",
                    modelValue: _ctx.formObject.form.description,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formObject.form.description) = $event)),
                    clearable: ""
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('i18n.formItems')), 1),
                    _createElementVNode("div", _hoisted_10, [
                      (_ctx.getFormItemsEditStatus)
                        ? (_openBlock(), _createBlock(_component_draggable, {
                            key: 0,
                            list: _ctx.availableFormItemsList,
                            group: { name: 'form_items', pull: 'clone', put: false },
                            sort: false,
                            "item-key": "id"
                          }, {
                            item: _withCtx(({ element, index }) => [
                              _createVNode(_component_FormItemCard, {
                                name: element.name,
                                iconName: element.icon,
                                onClick: ($event: any) => (_ctx.addFormItem(index)),
                                clickable: "",
                                draggable: ""
                              }, null, 8, ["name", "iconName", "onClick"])
                            ]),
                            _: 1
                          }, 8, ["list"]))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.availableFormItemsList, (element, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "cursor-not-allowed",
                              key: index
                            }, [
                              _createVNode(_component_FormItemCard, {
                                name: element.name,
                                iconName: element.icon
                              }, null, 8, ["name", "iconName"])
                            ]))
                          }), 128))
                    ])
                  ]),
                  _createVNode(_component_v_divider, {
                    thickness: 2,
                    class: "divider border-opacity-100 mt-3",
                    color: "black"
                  }),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('i18n.bilingual')), 1),
                    _createVNode(_component_v_switch, {
                      size: "x-small",
                      class: "form-option-btn",
                      modelValue: _ctx.bilingual,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bilingual) = $event)),
                      "hide-details": "",
                      focused: "",
                      color: "#ffd139"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('i18n.itemPerPage')), 1),
                    _createVNode(_component_v_switch, {
                      size: "small",
                      class: "form-option-btn",
                      modelValue: _ctx.formObject.form.layout_mode,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formObject.form.layout_mode) = $event)),
                      "hide-details": "",
                      focused: "",
                      color: "#ffd139",
                      value: 'one_per_page',
                      "false-value": 'all_on_one_page'
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_v_divider, {
                    thickness: 2,
                    class: "divider border-opacity-100 mb-3",
                    color: "black"
                  }),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('i18n.associateDevice')), 1),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.latestAssociatedDevice,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.latestAssociatedDevice) = $event)),
                    items: _ctx.availableDevicesList,
                    placeholder: _ctx.$t('i18n.deviceListPlaceholder'),
                    variant: "outlined",
                    density: "compact",
                    required: "",
                    "return-object": "",
                    "item-title": "name",
                    "item-value": "id",
                    "no-data-text": _ctx.$t('i18n.noDevicesAvailable')
                  }, null, 8, ["modelValue", "items", "placeholder", "no-data-text"]),
                  _createElementVNode("div", _hoisted_15, [
                    (_ctx.loadingDevices)
                      ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                          key: 0,
                          class: "skeleton-loader",
                          type: "card"
                        }))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devicesAssociatedToForm, (device) => {
                      return (_openBlock(), _createBlock(_component_v_chip, {
                        class: "gorate-chip mr-2 mb-2",
                        variant: "flat",
                        key: device.id,
                        label: "",
                        closable: "",
                        "onClick:close": ($event: any) => (_ctx.removeAssociatedDevice(device.id))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(device.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick:close"]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createTextVNode(_toDisplayString(_ctx.formObject.form.name) + " " + _toDisplayString(_ctx.$t('i18n.sketch')) + " ", 1),
                    (_ctx.displayedFormItemsList.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, "(" + _toDisplayString(_ctx.displayedFormItemsList.length) + " " + _toDisplayString(_ctx.$t('i18n.items')) + ")", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_draggable, {
                      class: "draggable-container",
                      list: _ctx.displayedFormItemsList,
                      sort: true,
                      group: { name: 'form_items' },
                      "item-key": "uuid",
                      onAdd: _ctx.handleDragToAdd,
                      onChange: _ctx.handleItemChangedisplayedFormItemsList
                    }, {
                      item: _withCtx(({ element, index }) => [
                        _createElementVNode("div", null, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(element.component_name), {
                            indexInTheSketchForm: index,
                            bilingual: _ctx.bilingual,
                            formItems: _ctx.getFormItemsIfEditing,
                            userCanEditFormItems: _ctx.getFormItemsEditStatus,
                            formList: _ctx.formList,
                            onRemoveItem: _ctx.removeItemFromSketch,
                            onDuplicateItem: _ctx.duplicateItemInSketch,
                            onFormItemUpdate: _ctx.updateFormData
                          }, null, 40, ["indexInTheSketchForm", "bilingual", "formItems", "userCanEditFormItems", "formList", "onRemoveItem", "onDuplicateItem", "onFormItemUpdate"]))
                        ])
                      ]),
                      _: 1
                    }, 8, ["list", "onAdd", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_v_divider, {
                      thickness: 2,
                      class: "border-opacity-100 mb-3",
                      color: "black"
                    }),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_v_btn, {
                        class: "ml-2 gorate-btn-bg-outlined",
                        onClick: _ctx.handleCancelFormDesignButtonClick,
                        variant: "flat"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('i18n.cancel')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_v_btn, {
                        class: "ml-2 gorate-btn-bg-outlined",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.formPreviewIsActive = true)),
                        variant: "flat"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('i18n.preview')), 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.formIdProp)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            class: "ml-2 gorate-btn-bg",
                            type: "submit",
                            variant: "flat"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('i18n.submit')), 1)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            class: "ml-2 gorate-btn-bg",
                            type: "submit",
                            variant: "flat"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('i18n.create')), 1)
                            ]),
                            _: 1
                          }))
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"]))
    ], 512),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.quitFormDesignModalIsActive,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.quitFormDesignModalIsActive) = $event)),
      "max-width": "450",
      onAfterLeave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isCancelFormDesign = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_QuitFormDesignModal, {
          modalTitle: _ctx.getQuitFormDesignDialogTitle,
          modalMessage: _ctx.getQuitFormDesignDialogMessage,
          onCloseModal: _ctx.cancelQuitNavigation,
          onConfirmQuitNavigation: _ctx.confirmQuitNavigation
        }, null, 8, ["modalTitle", "modalMessage", "onCloseModal", "onConfirmQuitNavigation"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.formPreviewIsActive,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formPreviewIsActive) = $event)),
      "max-width": "800"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FormPreview, {
          formObject: _ctx.formObject,
          propBilingual: _ctx.bilingual,
          onClosePreview: _ctx.closeFormPreview
        }, null, 8, ["formObject", "propBilingual", "onClosePreview"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}